import { SvgIcon, SvgIconProps } from '@mui/material'

export function EditTwo(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 3.75a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h16a.25.25 0 0 0 .25-.25v-7a.75.75 0 0 1 1.5 0v7A1.75 1.75 0 0 1 20 21.75H4A1.75 1.75 0 0 1 2.25 20V4c0-.966.784-1.75 1.75-1.75h7a.75.75 0 0 1 0 1.5H4Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.347 2.25a.75.75 0 0 1 .531.22l3.652 3.654a.75.75 0 0 1 0 1.06L11.19 17.53a.75.75 0 0 1-.53.22H7a.75.75 0 0 1-.75-.75v-3.64a.75.75 0 0 1 .22-.53L16.816 2.47a.75.75 0 0 1 .53-.22Zm0 1.811-9.597 9.61v2.579h2.598l9.592-9.596-2.592-2.593Z"
        clipRule="evenodd"
      />
    </SvgIcon>
  )
}

export default EditTwo
